__turbopack_context__.v({
  "auroraA": "login-left-background-effects-module__SYdlDq__auroraA",
  "auroraB": "login-left-background-effects-module__SYdlDq__auroraB",
  "auroraC": "login-left-background-effects-module__SYdlDq__auroraC",
  "auroraFloatA": "login-left-background-effects-module__SYdlDq__auroraFloatA",
  "auroraFloatB": "login-left-background-effects-module__SYdlDq__auroraFloatB",
  "auroraFloatC": "login-left-background-effects-module__SYdlDq__auroraFloatC",
  "cubeRotate": "login-left-background-effects-module__SYdlDq__cubeRotate",
  "floatingLogoDrift": "login-left-background-effects-module__SYdlDq__floatingLogoDrift",
  "floatingLogoField": "login-left-background-effects-module__SYdlDq__floatingLogoField",
  "floatingLogoGlow": "login-left-background-effects-module__SYdlDq__floatingLogoGlow",
  "floatingLogoInner": "login-left-background-effects-module__SYdlDq__floatingLogoInner",
  "floatingLogoMark": "login-left-background-effects-module__SYdlDq__floatingLogoMark",
  "floatingLogoOrbit": "login-left-background-effects-module__SYdlDq__floatingLogoOrbit",
  "floatingLogoTravel": "login-left-background-effects-module__SYdlDq__floatingLogoTravel",
  "mesh": "login-left-background-effects-module__SYdlDq__mesh",
  "meshDrift": "login-left-background-effects-module__SYdlDq__meshDrift",
  "particle": "login-left-background-effects-module__SYdlDq__particle",
  "particleFloat": "login-left-background-effects-module__SYdlDq__particleFloat",
  "particles": "login-left-background-effects-module__SYdlDq__particles",
  "root": "login-left-background-effects-module__SYdlDq__root",
  "titleGlow": "login-left-background-effects-module__SYdlDq__titleGlow",
  "titleGlowPulse": "login-left-background-effects-module__SYdlDq__titleGlowPulse",
  "wireframeCube": "login-left-background-effects-module__SYdlDq__wireframeCube",
  "wireframeCubeInner": "login-left-background-effects-module__SYdlDq__wireframeCubeInner",
  "wireframeFace": "login-left-background-effects-module__SYdlDq__wireframeFace",
});
